import { Reveal } from "./Reveal";
import { STEPS } from "./data";

export default function Process() {
  return (
    <section
      id="ablauf"
      data-testid="repair-process-section"
      className="relative border-y border-white/10 bg-[#0d0f17] py-24 sm:py-32"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-blue-400">
            (02) — Ablauf
          </p>
          <h2 className="mt-4 font-display text-3xl font-extrabold text-slate-50 sm:text-5xl">
            In drei Schritten <span className="text-outline">zurück im Leben.</span>
          </h2>
        </Reveal>

        <div className="mt-16 grid gap-px overflow-hidden rounded-2xl border border-white/10 bg-white/10 md:grid-cols-3">
          {STEPS.map((s, i) => (
            <Reveal key={s.step} delay={i * 0.12} className="h-full bg-[#0d0f17]">
              <div
                data-testid={`process-step-${s.step}`}
                className="group h-full p-8 transition-colors duration-500 hover:bg-[#141724] sm:p-10"
              >
                <span className="font-mono text-xs uppercase tracking-[0.25em] text-slate-500">
                  Schritt
                </span>
                <p className="mt-2 font-display text-5xl font-extrabold text-blue-400/90">
                  {s.step}
                </p>
                <h3 className="mt-6 font-display text-xl font-bold text-slate-50">
                  {s.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-400">
                  {s.desc}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
